import * as i0 from '@angular/core';
import { Pipe, SecurityContext, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafePipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafePipe, name: "safe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safe' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class SetAttributePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, element, attribute) {
        if (element && attribute) {
            const str = this.sanitizer.sanitize(SecurityContext.HTML, value);
            const newValue = str.replace(element, element.substring(0, element.length - 1) + ' ' + attribute + '>');
            return this.sanitizer.bypassSecurityTrustHtml(newValue);
        }
        return value;
    }
}
SetAttributePipe.Strike = {
    elem: '<s>',
    attr: 'aria-hidden="true"',
};
SetAttributePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SetAttributePipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SetAttributePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SetAttributePipe, name: "setAttribute" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SetAttributePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'setAttribute' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class AutoCompleteHighlight {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(text, value) {
        const regex = new RegExp(`(${value})`, 'ig');
        const str = this.sanitizer.sanitize(SecurityContext.HTML, text);
        const newValue = str.replace(regex, `<strong>$1</strong>`);
        return this.sanitizer.bypassSecurityTrustHtml(newValue);
    }
}
AutoCompleteHighlight.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteHighlight, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
AutoCompleteHighlight.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteHighlight, name: "autoCompleteHighlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AutoCompleteHighlight, decorators: [{
            type: Pipe,
            args: [{ name: 'autoCompleteHighlight' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class CtaAriaLabelPipe {
    constructor() {
        this.regexToStripTags = /(<([^>]+)>)/gi;
    }
    transform(args) {
        if (Array.isArray(args)) {
            return args.filter(Boolean).join(' ').replace(this.regexToStripTags, '');
        }
        const label = [];
        if (args) {
            label.push(args.heading || undefined);
            label.push(args.copy || undefined);
            label.push(args.description || undefined);
            label.push(args.alt || undefined);
            label.push(args.a11yDescription || undefined);
        }
        return label.filter(Boolean).join(' ').replace(this.regexToStripTags, '');
    }
}
CtaAriaLabelPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CtaAriaLabelPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CtaAriaLabelPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CtaAriaLabelPipe, name: "ctaAriaLabel" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CtaAriaLabelPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'ctaAriaLabel' }]
        }], ctorParameters: function () { return []; } });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PipesModule, declarations: [AutoCompleteHighlight,
        SafePipe,
        SetAttributePipe,
        CtaAriaLabelPipe], exports: [AutoCompleteHighlight,
        SafePipe,
        SetAttributePipe,
        CtaAriaLabelPipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PipesModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AutoCompleteHighlight,
                        SafePipe,
                        SetAttributePipe,
                        CtaAriaLabelPipe,
                    ],
                    exports: [
                        AutoCompleteHighlight,
                        SafePipe,
                        SetAttributePipe,
                        CtaAriaLabelPipe,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AutoCompleteHighlight, CtaAriaLabelPipe, PipesModule, SafePipe, SetAttributePipe };
